<template>
  <div>
    <custom-actions :panel="false">
      <template #header>
        <el-button v-if="hasAdd" type="primary"
                   @click="$router.push('/ycuserPayer/add')">新增权限</el-button>
      </template>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="账号" prop="userName"></el-table-column>
        <el-table-column min-width="300" label="采购方" prop="payerNames"></el-table-column>

        <el-table-column width="120" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" v-if="hasEdit" @click="$router.push('/ycuserPayer/edit?userId=' + row.userId)">编辑</el-button>
            <el-button type="text" v-if="hasDel" @click="deleteRow(row.userId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

<!--      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"-->
<!--        @current-change="loadData">-->
<!--      </el-pagination>-->
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'UserPayer',
  mixins: [keepAlive],
  data() {
    return {
      tableData: [],
      // page: 1,
      // total: 0,
      loading: false
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  methods: {
    loadData() {
      this.$axios
        .get(this.$apis.yxcUserPayer.selectYxcUserPayerByPage, {})
        .then(res => {
          this.tableData = res.list || []
          // this.total = res.total || 0
        })
    },
    deleteRow(userId) {
      this.$confirm('确认删除该账号权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.yxcUserPayer.deleteDataYxcUserPayer, {
          userId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
